<template>
  <PagesThankYou
    v-if="confGlobal.site === 'customusb' && params?.slugId === 'thank-you-108'"
  />

  <div
    v-else-if="params?.slugId === 'card-payment-111'"
  >
    <PagesCardPayment />
  </div>

  <component
    :is="componentName"
    v-else-if="componentName"
    :key="`page_${pageData?.page?.id}_${key}_custom`"
    :data="{
      ...pageData,
      sections
    }"
  />

  <div
    v-else-if="sections"
    :key="`page_${pageData?.page?.id}_${key}`"
    class="page"
  >
    <template 
      v-for="widget, i in sections"
    >
      <LazyWidgets
        v-if="widget?.widgetEnable && i >= 0 && widget.widgetId !== 'PagesObjectData'"
        :id="widget.widgetId"
        :key="`pageWidget_${i}`"
        :index-component="i"
        :set="defaultFields = widget.widgetPresetId && confWidgets.presets[widget.widgetId] && confWidgets.presets[widget.widgetId][widget.widgetPresetId]
          ? confWidgets.presets[widget.widgetId][widget.widgetPresetId].data
          : confPage.widgets.find(n => n.widgetId === widget.widgetId)
            ? confPage.widgets.find(n => n.widgetId === widget.widgetId).data
            : {}"
        :page-data="{
          ...pageData,
          sections
        }"
        :widget-enable="widget?.widgetEnable"
        :widget-default-fields-enable="widget.widgetDefaultFieldsEnable || (widget.widgetPresetId ? true : false)"
        :data="assignWidgetOptions(defaultFields, widget.data)"
        @visible-products="(e) => {
          gtmViewItemList(e)
        }"
      />
    </template>
  </div>
</template>

<script setup>
const { params } = useRoute()
const { trackEventQueue } = useCustomTools()
const { assignWidgetOptions } = useWidgets()
const { confGlobal, confWidgets, confPage } = useConfig()
const { getBreadcrumbs } = useBreadcrumbs()

const indexId = 1
const key = ref(1)
const layoutName = ref(false)

/**
* Get Page data
*/
const { data: pageData, error } = await useGetPage(params?.slugId ? params?.slugId : indexId)

if (error.value || !pageData.value) {
  throw createError(error.value)
}

/**
* Layout Name
*/
layoutName.value = pageData.value?.page?.layout_name

/**
* Get Breadcrumbs
*/
getBreadcrumbs(pageData.value, 'page')

/*
* Sections (Widgets)
*/
const sections = computed({
  get() {
    return pageData.value?.page?.content_json ? JSON.parse(pageData.value.page.content_json) : []
  }
})

/**
* Component Name
*/
const componentName = computed({
  get() {
    return layoutName.value ? defineComponent('PagesLandings' + (layoutName.value === 'Index' ? '' : layoutName.value)) : false
  }
})

/**
* Meta Tags
*/
useHead({
  title: pageData?.value?.page?.headTitle,
  meta: [{
    name: 'description',
    content: pageData?.value?.page?.meta_description
  },
  {
    name: 'keywords',
    content: pageData?.value?.page?.metaKeywords
  }]
})

if (params?.slugId === 'help-ukraine-126') {
  useHead({
    link: [
      { rel: 'apple-touch-icon', sizes: '180x180', href: '/img/ukraine-apple-touch-icon.png' },
      { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/img/ukraine-favicon-32x32.png' },
      { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/img/ukraine-favicon-16x16.png' },
      { rel: 'icon', type: 'image/svg+xml', href: '/img/ukraine-favicon.svg' }
    ]
  })
}

/**
* GTM
* @event view_item
*/
trackEventQueue.value.push({ ecommerce: null })

const productsItems = []
let gtmTimer = ''
const gtmViewItemList = (items) => {
  clearTimeout(gtmTimer)
  if (pageData.value?.page) {
    trackEventQueue.value.push({
      event: 'view_item',
      ecommerce: {
        item_list_id: indexId === pageData.value?.page?.id ? confGlobal.currentSiteUrl : `${confGlobal.currentSiteUrl}/page/${pageData.value?.page?.url_path_name}-${pageData.value?.page?.id}`,
        item_list_name: pageData.value?.page?.title,
        items: productsItems.concat(items)
      }
    })
  }
}

gtmTimer = setTimeout(() => {
  gtmViewItemList([])
}, 500)
</script>

<style lang="scss" scoped>
</style>
